import i18n from "../../i18n";
const localize = (keys) => {
    let message = "";
    if (!Array.isArray(keys))
        return "";
    keys.forEach((item) => (message += i18n.t(item) + " "));
    return message.trim();
};
export default localize;
